import React from 'react'
import { Link } from 'react-router-dom'
import logo from 'app/livbrite/resources/images/livBrite_logo.png'
import { NewsletterForm } from './components/NewsletterForm'
import { Contact } from './components/Contact'
import { CommunityLinks } from './components/CommunityLinks'
import { FooterLinks } from './components/FooterLinks'
import { LegalLinks } from './components/LegalLinks'
import { Container, FooterLogo } from './styled'

export const Footer = () => {
  return (
    <Container>
      <div>
        <NewsletterForm />
        <div className='footer__main-column'>
          <Contact />
          <CommunityLinks />
          <FooterLinks />
        </div>
        <FooterLogo>
          <Link to='/'>
            <img src={logo} alt='LivBrite' />
          </Link>
        </FooterLogo>
        <LegalLinks />
      </div>
    </Container>
  )
}
